<template>
  <header class="l-header" id="id-header">
    <h1 v-if="$route.name == 'homePage'" class="header-seo">{{ titleSeo }}</h1>
    <div id="header-optional" class="position-absolute"></div>
    <router-link :to="{ name: 'homePage', params: { locale: localeTemp } }" class="main-logo">
      <picture>
        <img
          class="logo-bella"
          :style="displayModelPage"
          width="258"
          height="42"
          :src="isMobile() ? logoHorizontalMobile : logoHorizontal"
          :srcset="isMobile() ? logoHorizontalMobile : logoHorizontal"
          alt="Logo Bella da Semana"
        />
      </picture>
    </router-link>
    <!-- Social Links -->
    <ul class="social-box social-box--dark d-none d-md-flex">
      <li v-for="(icon, index) in icones" :key="index">
        <a :href="icon.link" target="_blank"
          ><img :src="icon.src" alt="Social Link" width="25" height="25" class="icon-header"
        /></a>
      </li>
    </ul>

    <!-- Languages -->

    <div class="language-nav dropdown nav-mobile">
      <a
        href="#"
        class="dropdown-toggle"
        id="language"
        data-toggle="dropdown"
        @click.prevent="showLangMenu = !showLangMenu"
      >
        <img :src="langLinks[setIdLang].flag" :alt="langLinks[setIdLang].fullName" />
        <span v-if="!isMobile()">{{ langLinks[setIdLang].name }}</span>
      </a>
      <div class="dropdown-menu header-menu" :class="{ show: showLangMenu }" aria-labelledby="language">
        <a
          href="#"
          v-for="(link, i) in langLinks"
          :key="i"
          class="dropdown-item"
          @click.prevent="changeLang(link.lang)"
        >
          <img :src="link.flag" :alt="link.fullName" />
          <span class="language-label">{{ link.name }}</span>
        </a>
      </div>
    </div>
    <!--Top Nav -->

    <nav class="navbar">
      <ul>
        <li
          class="navbar__item text-center d-none d-xl-block"
          v-for="{ key, name, link, bold } in listNavbar"
          :key="key"
          @click="redirect(link)"
        >
          <span :class="`nav-menu-header ${bold}`">{{ name }}</span>
        </li>

        <li
          class="navbar__item navbar__item--highlight text-center"
          @click="redirect('AssineOptionsPage')"
        >
          <span class="nav-menu-header-assine">{{
            storeUser.isLoggedIn
              ? navMainHeaderTradLanguage.nav.pageSubscribeLogin
              : navMainHeaderTradLanguage.nav.pageSubscribeLogout
          }}</span>
        </li>
      </ul>
    </nav>
    <div class="burger-wrapper">
      <a href="#" class="burger-icon" @click.prevent="showMenuLateral()">
        <div class="d-flex align-items-center w-100">
          <div class="w-50">
            <div class="menu-hifens">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="nav-menu-header-name menu-mobile ps-1">MENU</div>
        </div>
      </a>
    </div>
    <RightNavbar
      @showMenuLateral="showMenuLateral"
      :class="{ 'show-menu': show }"
      class="right-menu"
    />
  </header>
</template>

<script setup lang="ts">
  import translate from '../../../tradutors/mainheader'
  import FlagUnitedStates from 'assets/img/Flag_of_the_United_States.webp'
  import FlagBrasil from 'assets/img/Flag_of_Brazil.webp'
  import { localeStore } from '../../../stores/locale'
  import { userStore } from '../../../stores/user'
  import router from '../../../router'
  import { isMobile } from '../../shared/utils/mobile'
  //Icones
  import Telegram from 'assets/img/telegram.webp'
  import Topfans from 'assets/img/topfans.webp'
  import Twitter from 'assets/img/twitter.webp'
  import Whatsapp from 'assets/img/whatsapp.webp'
  import logoHorizontal from 'assets/img/logo_BDS_horizontal_small.webp'
  import logoHorizontalMobile from 'assets/img/logo_BDS_horizontal_small_mobile.webp'
  import RightNavbar from '../Navbar/RightNavbar.vue'
  import { useRoute } from 'vue-router'
  import { computed, onBeforeMount, onMounted, ref, watch } from 'vue'

  const props = defineProps({
    show: {
      type: Boolean,
      default: false
    }
  })

  const route = useRoute()

  const emit = defineEmits(['showMenuLateral'])

  const storeLocale = localeStore()
  const storeUser = userStore()

  const navMainHeaderTradLanguage = computed(() => {
    return storeLocale.locale === 'pt-br' ? translate.portugues : translate.ingles
  })

  const langLinks = ref([
    {
      name: 'PT',
      lang: 'pt-br',
      fullName: 'Português',
      flag: FlagBrasil
    },
    {
      name: 'EN',
      lang: 'en',
      fullName: 'English',
      flag: FlagUnitedStates
    }
  ])
  const listNavbar = ref([])

  const icones = ref([
    { src: Telegram, link: 'https://t.me/belladasemanaoficial' },
    { src: Topfans, link: 'https://topfans.me/bella' },
    /*
    {
      src: Youtube,
      link: 'https://www.youtube.com/channel/UCAjpZH6H-Tqt5JI7F3dPeTA'
    },
    */
    { src: Twitter, link: 'https://twitter.com/belladasemana' },
    { src: Whatsapp, link: 'https://chat.whatsapp.com/IS3rWOWDnLeIyNQbvDfGdq' }
  ])

  const setIdLang = ref(0)
  const localeTemp = ref('pt-br')
  const showLangMenu = ref(false)

  const displayModelPage = computed(() => {
    return (route.name == 'ModelPage' || route.name == 'ModelPageChild') && isMobile()
      ? { display: 'none' }
      : { display: 'block' }
  })
  const titleSeo = ref('')

  onBeforeMount(() => {
    localeTemp.value = String(route.params.locale)
    let langsAccepts = ['pt-br', 'en']

    if (langsAccepts.includes(localeTemp.value)) storeLocale.setLocale(localeTemp.value)
    else router.push({ name: 'homePage', params: { locale: 'pt-br' } })

    titleSeo.value = localeTemp.value == 'pt-br' ? 'Bella da Semana' : 'Bella Club'
    setIdLang.value = localeTemp.value === 'en' ? 1 : 0
  })

  onMounted(() => {
    listItems()
  })

  function redirect(name: string) {
    router.push({ name, params: { locale: localeTemp.value } })
  }

  function changeLang(locale: string) {
    showLangMenu.value = false
    // after this change a hook will trigger
    storeLocale.setLocale(locale)

    localeTemp.value = locale

    let newUrl = router.currentRoute.value.fullPath
    localeTemp.value == 'pt-br'
      ? (newUrl = newUrl.replace(/en/, localeTemp.value))
      : (newUrl = newUrl.replace(/pt-br/, localeTemp.value))

    router.replace(newUrl)
  }
  function showMenuLateral() {
    emit('showMenuLateral', !props.show)
  }

  function listItems() {
    setIdLang.value = localeTemp.value === 'en' ? 1 : 0
    listNavbar.value = [
      {
        name: navMainHeaderTradLanguage.value.nav.models,
        key: 1,
        link: 'ModelsPage',
        bold: route.name == 'ModelsPage' ? 'item-bold' : ''
      },
      {
        name: navMainHeaderTradLanguage.value.nav.videos,
        key: 2,
        link: 'VideosPage',
        bold: route.name == 'VideosPage' ? 'item-bold' : ''
      },
      {
        name: navMainHeaderTradLanguage.value.nav.lives,
        key: 3,
        link: 'LivesPage',
        bold: route.name == 'LivesPage' ? 'item-bold' : ''
      },
      {
        name: navMainHeaderTradLanguage.value.nav.freeTour,
        key: 4,
        link: 'FreeTourPage',
        bold: route.name == 'FreeTourPage' ? 'item-bold' : ''
      },
      {
        name: storeUser.isLoggedIn
          ? navMainHeaderTradLanguage.value.nav.minhaConta
          : navMainHeaderTradLanguage.value.nav.login,
        key: 5,
        link: storeUser.isLoggedIn ? 'MyAccountPage' : 'LoginPage',
        bold: route.name == 'MyAccountPage' || route.name == 'LoginPage' ? 'item-bold' : ''
      }
    ]
  }

  watch(
    () => localeTemp.value,
    () => {
      listItems()
    }
  )

  watch(
    () => storeUser.isLoggedIn,
    () => {
      listItems()
    }
  )

  watch(
    () => storeLocale.locale,
    (value) => {
      localeTemp.value = value
      listItems()
    }
  )
</script>

<style lang="scss">
  .burger-wrapper {
    width: 104px;
    height: 100%;
    position: relative;
    margin-top: 4px;

    .burger-icon {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      z-index: 103;

      span {
        display: block;
        width: 18px;
        height: 2px;
        margin-bottom: 3px;
        background: #1d1d1d;
        border-radius: 3px;
        transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease;
      }
    }
  }

  .language-nav {
    width: 60px;
    height: 24px;
    margin: 10px;
    display: block;
  }

  .language-nav a img {
    border-radius: 50%;
    width: 22px;
    height: 22px;
    object-fit: cover;
    top: -2px;
  }

  .language-nav a {
    font-family: 'Exo-2';
    vertical-align: unset;
    top: 0px;
    color: #666666;
  }

  .language-nav .dropdown-toggle:after {
    top: -1px;
    color: rgba(0, 0, 0, 0.5);
  }

  .logo-bella {
    display: block;
    width: 258px;
    height: 42px;
  }

  .nav-menu-header {
    height: 24px;
    width: 63px;
    color: #000000;
    font-family: 'Bebas-Neue';
    font-size: 20px;
    letter-spacing: 1px;
    line-height: 24px;
    font-weight: 400;
  }

  .nav-menu-header-name {
    color: #000000;
    font-family: 'Bebas-Neue';
    font-size: 20px;
    letter-spacing: 0;
    line-height: 24px;
    padding-right: 20px;
  }

  .nav-menu-header-assine {
    height: 24px;
    width: 63px;
    color: #ffffff;
    font-family: 'Bebas-Neue';
    font-size: 20px;
    letter-spacing: 0;
    line-height: 24px;
    top: 3px;
  }

  .navbar__item {
    width: 115px;
    height: 65px;
    line-height: 65px;
    padding: 0px;
    border-color: rgba(0, 0, 0, 0.1);
  }

  .navbar__item--highlight {
    font-family: 'Bebas-Neue';
  }

  .social-box li {
    margin-right: 9px;
  }

  //facebook
  .social-box li:nth-child(1) i {
    font-size: 23px;
    left: 2px;
    top: 0px;
  }

  //twitter
  .social-box li:nth-child(2) i {
    font-size: 24px;
    left: -2px;
    top: -1px;
  }

  //youtube
  .social-box li:nth-child(3) i {
    font-size: 16px;
    left: -2px;
    top: -1px;
  }

  //rss
  .social-box li:nth-child(4) i {
    font-size: 18px;
    top: 0px;
  }

  .menu-mobile {
    transform: translate(0%, 0%);
  }

  .header-seo {
    position: absolute;
    color: white;
    z-index: -1;
  }

  .l-header {
    position: fixed !important;
    height: 65px !important;
  }

  .item-bold {
    font-weight: 700;
  }

  .menu-hifens {
    float: right;
  }

  .down-menu {
    top: -85px;
  }

  .dropdown-menu {
    background-color: #ffffff;
  }

  .header-menu { 
    z-index: 109;
  }  

  @media (min-width: 769px) {
    .main-logo {
      width: 258px;
      height: 40px;
      margin-left: 35px;
    }
  }

  @media screen and (max-width: 769px) {
    .navbar__item {
      width: 100px;
    }

    .burger-wrapper {
      max-width: 85px;
    }

    .l-header,
    .navbar__item {
      height: 65px;
      line-height: 65px;
    }

    #header-optional {
      color: #000000;
      font-family: 'Roboto-Medium';
      font-size: 13px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 16px;
      z-index: 100;
      top: 17px;
    }

    .menu-mobile {
      font-size: 19px;
      transform: translate(5%, 5%);
    }

    .language-nav a {
      top: -20px;
    }

    .nav-mobile {
      left: 10px;
    }
    .nav-menu-header-assine {
      top: 5px;
    }

    .dropdown-item {
      height: 40px;
    }

    .menu-hifens {
      left: 5px;
    }

    .down-menu {
      top: -110px;
    }
    .header-menu { 
      top: 30px;
    }    
  }

  @media screen and (max-width: 769px) {
    .logo-bella {
      width: 130px;
      height: 40px;
      top: -3px;
    }
  }
</style>
